import { Component } from "react";
import "./IntegrationsConnectedBar.scss";

import * as _ from "lodash-es";

import qboLogo from "../../../assets/images/quickbooks/QB_16x16.png";
import shipstationLogo from "../../../assets/images/shipstation/shipstation-logo-white.png";
import squareLogo from "../../../assets/images/square/square-logo-white.png";
import zohoLogo from "../../../assets/images/zoho/zoho-crm-logo.svg";
import woocommerceLogo from "../../../assets/images/woocommerce/woocommerce-icon.svg";
import IIntegrations from "../../../models/IIntegrations";
import shopifyLogo from "../../../assets/images/shopify/shopify-icon.svg";
import fishbowlLogo from "../../../assets/images/fishbowl/fishbowl-logo-32x32.png";
import openCartLogo from "../../../assets/images/opencart/opencart-icon.svg";
import xeroLogo from "../../../assets/images/xero/Logo - Blue.png";
import wayfairLogo from "../../../assets/images/wayfair/wayfair-icon.svg";
import hubspotLogo from "../../../assets/images/hubspot/hubspot-icon.svg";
import fastboundLogo from "../../../assets/images/fastbound/fastbound-icon.png";
import ISupplierModel from "../../../models/ISupplierModel";

type Props = {
    supplierModel: ISupplierModel;
    qboConnected?: any;
    shipstationConnected?: any;
    squareConnected?: any;
    zohoConnected?: any;
    wooCommerceConnected?: any;
    fishbowlConnected?: any;
    qbdConnected?: any;
    shopifyConnected?: any;
    openCartConnected?: any;
    xeroConnected?: any;
    hubspotConnected?: any;
    otherConnected?: any;
    appConnected?: any;
    wayfairConnected?: any;
    ecommConnected?: any;
    fastboundConnected?: any;
    position?: "center" | "left";
    hideIntegrations?: IIntegrations;
    showIntegrations?: IIntegrations;
    className?: string;
};

type State = {
    hasQbo: boolean;
    hasShipstation: boolean;
    hasSquare: boolean;
    hasZoho: boolean;
    hasQbd?: boolean;
    hasWooCommerce?: boolean;
    hasShopify?: boolean;
    hasFishbowl?: boolean;
    hasOpenCart?: boolean;
    hasApp?: boolean;
    hasEcommCart?: boolean;
    hasOther?: boolean;
    hasXero?: boolean;
    hasWayfair?: boolean;
    hasHubspot?: boolean;
    hasFastbound?: boolean;
};

class IntegrationsConnectedBar extends Component<Props, State> {
    static defaultProps = {
        position: "right",
        hideIntegrations: {
            quickbooksOnline: false,
            quickbooksDesktop: false,
            shipstation: false,
            square: false,
            zoho: false,
            wooCommerce: false,
            shopify: false,
            fishbowl: false,
            opencart: false,
            app: false,
            other: false,
            xero: false,
            hubspot: false,
            ecommCart: false,
            fastbound: false,
        },
        showIntegrations: {
            quickbooksOnline: false,
            quickbooksDesktop: false,
            shipstation: false,
            square: false,
            zoho: false,
            wooCommerce: false,
            shopify: false,
            fishbowl: false,
            opencart: false,
            app: false,
            other: false,
            xero: false,
            hubspot: false,
            ecommCart: false,
            fastbound: false,
        },
    };

    readonly state: State = {
        hasQbo: true,
        hasShipstation: false,
        hasSquare: false,
        hasZoho: false,
        hasQbd: false,
        hasWooCommerce: false,
        hasShopify: false,
        hasFishbowl: false,
        hasOpenCart: false,
        hasApp: true,
        hasOther: true,
        hasXero: false,
        hasEcommCart: false,
        hasFastbound: false,
    };

    componentDidMount() {
        const hasQbo = _.get(this.props.supplierModel, "Supplier_Integration.has_qbo", false);
        const hasShipstation = _.get(this.props.supplierModel, "Supplier_Integration.has_shipstation", false);
        const hasSquare = _.get(this.props.supplierModel, "Supplier_Integration.has_square", false);
        const hasZoho = _.get(this.props.supplierModel, "Supplier_Integration.has_zoho", false);
        const hasQbd = _.get(this.props.supplierModel, "Supplier_Integration.has_qbd", false);
        const hasWooCommerce = _.get(this.props.supplierModel, "Supplier_Integration.has_woocommerce", false);
        const hasShopify = _.get(this.props.supplierModel, "Supplier_Integration.has_shopify", false);
        const hasFishbowl = _.get(this.props.supplierModel, "Supplier_Integration.has_fishbowl", false);
        const hasOpenCart = _.get(this.props.supplierModel, "Supplier_Integration.has_opencart", false);
        const hasXero = _.get(this.props.supplierModel, "Supplier_Integration.has_xero", false);
        const hasWayfair = _.get(this.props.supplierModel, "Supplier_Integration.has_wayfair", false);
        const hasHubspot = _.get(this.props.supplierModel, "Supplier_Integration.has_hubspot", false);
        const hasFastbound = _.get(this.props.supplierModel, "Supplier_Integration.has_fastbound", false);
        const hasEcommCart = true;

        this.setState({
            hasQbo,
            hasShipstation,
            hasSquare,
            hasZoho,
            hasQbd,
            hasWooCommerce,
            hasShopify,
            hasFishbowl,
            hasOpenCart,
            hasXero,
            hasWayfair,
            hasHubspot,
            hasEcommCart,
            hasFastbound,
        });
    }

    getFastbound = () => {
        if (this.state.hasFastbound && this.props.showIntegrations!.fastbound) {
            return (
                <img
                    alt={"Fastbound"}
                    src={fastboundLogo}
                    title={"Fastbound"}
                    height={16}
                    className={"ms-2 " + (this.props.fastboundConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getQuickBooksOnline = () => {
        if (this.state.hasQbo && this.props.showIntegrations!.quickbooksOnline) {
            return (
                <img
                    alt={"QuickBooks Online"}
                    src={qboLogo}
                    title={"QuickBooks Online"}
                    height={16}
                    className={"ms-2 " + (this.props.qboConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getQuickBooksDesktop = () => {
        if (this.state.hasQbd && this.props.showIntegrations!.quickbooksDesktop) {
            return (
                <img
                    alt={"QuickBooks Desktop"}
                    src={qboLogo}
                    title={"QuickBooks Desktop"}
                    height={16}
                    className={"ms-2 " + (this.props.qbdConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getShipstation = () => {
        if (this.state.hasShipstation && this.props.showIntegrations!.shipstation) {
            return (
                <img
                    alt={"ShipStation"}
                    src={shipstationLogo}
                    title={"ShipStation"}
                    height={16}
                    className={"ms-2 " + (this.props.shipstationConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getSquare = () => {
        if (this.state.hasSquare && this.props.showIntegrations!.square) {
            return (
                <img
                    alt={"Square"}
                    src={squareLogo}
                    title={"Square"}
                    height={16}
                    className={"ms-2 " + (this.props.squareConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getWayfair = () => {
        if (this.state.hasWayfair && this.props.showIntegrations!.wayfair) {
            return (
                <img
                    alt={"Wayfair"}
                    src={wayfairLogo}
                    title={"Wayfair"}
                    height={16}
                    className={"ms-2 " + (this.props.wayfairConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getZoho = () => {
        if (this.state.hasZoho && this.props.showIntegrations!.zoho) {
            return (
                <img
                    alt={"Zoho"}
                    src={zohoLogo}
                    title={"Zoho"}
                    height={16}
                    className={"ms-2 " + (this.props.zohoConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getHubspot = () => {
        if (this.state.hasHubspot && this.props.showIntegrations!.hubspot) {
            return (
                <img
                    alt={"Hubspot"}
                    src={hubspotLogo}
                    title={"Hubspot"}
                    height={16}
                    className={"ms-2 " + (this.props.hubspotConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getWooCommerce = () => {
        if (this.state.hasWooCommerce && this.props.showIntegrations!.wooCommerce) {
            return (
                <img
                    alt={"WooCommerce"}
                    src={woocommerceLogo}
                    title={"WooCommerce"}
                    height={16}
                    className={"ms-2 " + (this.props.wooCommerceConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getShopify = () => {
        if (this.state.hasShopify && this.props.showIntegrations!.shopify) {
            return (
                <img
                    alt={"Shopify"}
                    src={shopifyLogo}
                    title={"Shopify"}
                    height={16}
                    className={"ms-2 " + (this.props.shopifyConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getFishbowl = () => {
        if (this.state.hasFishbowl && this.props.showIntegrations!.fishbowl) {
            return (
                <img
                    alt={"Fishbowl"}
                    src={fishbowlLogo}
                    title={"Fishbowl"}
                    height={16}
                    className={"ms-2 " + (this.props.fishbowlConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getOpenCart = () => {
        if (this.state.hasOpenCart && this.props.showIntegrations!.opencart) {
            return (
                <img
                    alt={"OpenCart"}
                    src={openCartLogo}
                    title={"OpenCart"}
                    height={16}
                    className={"ms-2 " + (this.props.openCartConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getXero = () => {
        if (this.state.hasXero && this.props.showIntegrations!.xero) {
            return (
                <img
                    alt={"Xero"}
                    src={xeroLogo}
                    title={"Xero"}
                    height={27}
                    className={"ms-2 " + (this.props.xeroConnected ? "" : "dimmed")}
                />
            );
        } else {
            return null;
        }
    };

    getOther = () => {
        if (this.state.hasApp && this.props.showIntegrations!.other) {
            return <i title={"Other"} className={"fad fa-funnel-dollar ms-2" + (this.props.otherConnected ? "" : "dimmed")} />;
        } else {
            return null;
        }
    };

    getApp = () => {
        if (this.state.hasApp && this.props.showIntegrations!.app) {
            return <i title={"App"} className={"fad fa-mobile ms-2" + (this.props.appConnected ? "" : "dimmed")} />;
        } else {
            return null;
        }
    };

    getEcommCart = () => {
        if (this.state.hasEcommCart && this.props.showIntegrations!.ecommCart) {
            return (
                <i title={"Orderwerks Cart"} className={"fa-duotone fa-cart-shopping ms-2" + (this.props.ecommConnected ? "" : "dimmed")} />
            );
        } else {
            return null;
        }
    };

    render() {
        let positionClass = "justify-content-end"; // default is to the right side/end

        if (this.props.position === "center") {
            positionClass = "justify-content-center";
        } else if (this.props.position === "left") {
            positionClass = "justify-content-start";
        }

        return (
            <span className={this.props.className + " IntegrationsConnectedBar " + positionClass}>
                {this.getQuickBooksOnline()}
                {this.getQuickBooksDesktop()}
                {this.getXero()}
                {this.getShipstation()}
                {this.getSquare()}
                {this.getZoho()}
                {this.getWooCommerce()}
                {this.getShopify()}
                {this.getFishbowl()}
                {this.getOpenCart()}
                {this.getOther()}
                {this.getApp()}
                {this.getWayfair()}
                {this.getHubspot()}
                {this.getEcommCart()}
                {this.getFastbound()}
            </span>
        );
    }
}

export default IntegrationsConnectedBar;
